import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { JobEditorDialogTab } from '@core/offers-types';

export function injectOpenJobEditor() {
  const router = inject(Router);

  return (
    jobId: number | string,
    tab: JobEditorDialogTab,
    jobEditorType: 'job-editor' | 'job-template-editor' = 'job-editor',
    queryParams: { scrollToSection?: string } = {},
  ) => {
    router.navigate([{ outlets: { [jobEditorType]: [jobId, tab] } }], { queryParams });
  };
}
